import { http } from '../mock-http';
import mockResponse from './mock-master-data';

export default {
  getMasterData: typeId => http.get(mockResponse[typeId] || []),
};
